module.exports = __webpack_public_path__ + "508d3f70fcbaf4ffd41ce30a7962fe33.MP3";